import clsx from 'clsx';
import PropTypes from 'prop-types';

import Button from 'honeydew/Button';
import UpgradeIcon from 'honeydew/icons/MyPlan/UpgradeIcon';

function UpgradePlanBanner({ flush, openUpgradeModal }) {
    return (
        <div
            className={clsx(
                'bg-brand-secondary items-center !bg-opacity-50 p-30',
                { 'mt-20 rounded-md': !flush },
                { '-mx-20 -mb-25 mt-25 rounded-b-lg lg:-mx-30 lg:-mb-30 lg:mt-30': flush }
            )}
        >
            <div className="mx-auto max-w-[500px] items-center gap-20 md:flex">
                <div className="grid grid-cols-[60px_1fr] items-center justify-center gap-20">
                    <UpgradeIcon />
                    <p className="text-body-lg font-grotesk-bold">Upgrade to Grocery Subscription today</p>
                </div>
                <div className="mx-auto mt-20 w-[220px] md:mt-0">
                    <Button size="md" onClick={openUpgradeModal}>
                        Upgrade Plan
                    </Button>
                </div>
            </div>
        </div>
    );
}

UpgradePlanBanner.propTypes = {
    flush: PropTypes.bool,
    openUpgradeModal: PropTypes.func.isRequired,
};

UpgradePlanBanner.defaultProps = {
    flush: false,
};

export default UpgradePlanBanner;
